import {useRef} from 'react';
import {Button} from '@cvent/carina/components/Button';
import {Modal} from '@cvent/carina/components/Modal';
import {DismissButton} from '@cvent/carina/components/ScrollViewWithBars';

type ForgotPasswordSuccessModalProps = {
  handleClose: () => void;
};

const ForgotPasswordSuccessModal = ({
  handleClose,
}: ForgotPasswordSuccessModalProps) => {
  const headerRef = useRef<HTMLHeadingElement | null>(null);

  return (
    <Modal
      isOpen
      format="sm"
      onDismiss={handleClose}
      testID="forgot-password-success-modal"
      aria-labelledby="forgot-password-success-title"
    >
      <div className="flex flex-col box-border md:w-[420px] p-6 pt-4">
        <div className="flex items-start justify-between">
          <h1
            id="forgot-password-success-title"
            ref={headerRef}
            tabIndex={-1}
            className="text-[length:var(--carina-font-size-display-xs)] font-[var(--carina-font-weight-display)] leading-[var(--carina-line-height-display-xs)] pt-1"
          >
            Success!
          </h1>
          <DismissButton aria-label="Dismiss" onClick={handleClose} />
        </div>
        <div className="my-4 text-sm leading-[var(--carina-line-height-normal)] text-[var(--carina-text-color-soft)]">
          <p id="forgot-password-success-content">
            Email has been sent. Check your email address for more instructions.
          </p>
        </div>
        <div className="my-4 flex flex-col sm:flex-row gap-3 sm:justify-end">
          <Button
            text="Resend email"
            onClick={handleClose}
            type="button"
            appearance="ghost"
          />
          <Button
            text="Go to login"
            onClick={() => {
              window.location.href = '/new';
            }}
            type="button"
            appearance="filled"
          />
        </div>
      </div>
    </Modal>
  );
};

export default ForgotPasswordSuccessModal;
